export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-13-49afaf368a4af62a22e363db34dd7965.png";